import React from 'react';
import { CircularProgress } from '@mui/material';

export function Loader() {
  return <CircularProgress />;
}
